module.exports = __webpack_public_path__ + "Nick-0b7ea8e4.png";